<template>
  <section>
    <div style="height: 80dvh;">
      <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="100%"></iframe>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: 'Instruction',
  data() {
    return {
      pdfUrl: null
    }
  },
  mounted() {
    axios.get("api/pdf/instructions/eagent-usage.pdf", { responseType: 'blob' })
        .then(res => {
          this.pdfUrl = URL.createObjectURL(res.data)
    })
  },
  methods: {
  }
}
</script>

<style scoped>

</style>